import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.TIPOS_DOCUMENTO.BUSCAR]() {
		const { data } = await api.tipoDocumento.buscarTiposDocumento()
		return data
	},
}
